import React from 'react';
import darkPreloaderLogo from '../assets/AppImages/royalty-logo-preloader-dark.png';
import lightPreloaderLogo from '../assets/AppImages/royalty-logo-preloader-light.png';

const LoadingOverlay = ({ isFailed, onRetry, theme = 'light', variant = 'boot' }) => {
  const isLightTheme = theme === 'light';
  const logoSrc = isLightTheme ? lightPreloaderLogo : darkPreloaderLogo;

  return (
    <div
      className={`backend-loading-overlay theme-${isLightTheme ? 'light' : 'dark'} is-${variant} ${isFailed ? 'is-failed' : 'is-loading'}`}
      role={isFailed ? 'alert' : 'status'}
      aria-live="polite"
      aria-label={isFailed ? 'Connection issue' : 'Loading DeRoyalty Car Rental'}
    >
      <div className="loading-content brand-preloader-card">
        <div className="brand-preloader-logo-wrap" aria-hidden="true">
          <img
            src={logoSrc}
            alt=""
            className="brand-preloader-logo"
          />
        </div>
        {!isFailed ? (
          <>
            <span className="brand-preloader-kicker">DeRoyalty Car Rental</span>
            <span className="brand-preloader-line" aria-hidden="true" />
          </>
        ) : (
          <>
            <div className="boot-error-icon" aria-hidden="true">
              <i className="bi bi-wifi-off"></i>
            </div>
            <h3 className="loading-text mb-2">
              We're having trouble connecting to our servers.
            </h3>
            <button className="boot-retry-btn" onClick={onRetry}>
              Try Again
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
